import 'moment/locale/nb';
import React, {
  useState, useEffect,
} from 'react';
import Tabs, { Tab } from 'src/components/Tabs';
import {
  getBrandingLinks,
  linkTypes,
} from 'src/branding';
import Helptext from 'src/components/Helptext';
import axiosInstance from 'src/axios-instance';
import {
  MainHeaderWrapper,
  EnrolmentInfoLink,
} from './Components';
import { IconBadgeNumber } from '../Dashboard/Dashboard';
import { backendUrl } from '../../config';
import { InfoBubble } from '../../components/InfoBubble';
import { routes } from '../routes.manifest';
import { Label } from '../../components/Layout';

export const MainHeader = ({ ieHeightAdjust, pathname, push }) => {
  const [unreadEnrolmentCount, setUnreadEnrolmentCount] = useState(null);

  // get unread count
  useEffect(() => {
    axiosInstance
      .request({
        method: 'GET',
        url: `${backendUrl}/api/registered_enrolment_unread`,
        withCredentials: true,
      })
      .then(({ data }) => data && setUnreadEnrolmentCount(data.count));
  }, []);

  return (
    <div style={{ paddingLeft: '1.2em' }}>
      <MainHeaderWrapper ieHeightAdjust={ieHeightAdjust}>
        <Label
          font="serif"
          as="h1"
          size="2.5em"
          name="main-header"
          color="#68696d"
          marginBottom="0.5em"
        >
          Innmeldinger
        </Label>
      </MainHeaderWrapper>
      {getBrandingLinks(linkTypes.registerEnrolmentInfo)
        ? (
          <EnrolmentInfoLink
            href={getBrandingLinks(linkTypes.registerEnrolmentInfo)}
            target="_blank"
          >
            Mer informasjon om innmelding
          </EnrolmentInfoLink>
        )
        : (
          <div style={{ display: 'flex', marginBottom: '1em' }}>
            <Label>Informasjon on innmelding</Label>
            <InfoBubble
              popupStyle={{
                position: 'absolute',
                top: '26px',
                left: '-120px',
                minWidth: '12em',
              }}
              style={{
                position: 'relative',
                left: '0.3em',
                bottom: '0.2em',
              }}
            >
              <Helptext name="enrolment-info" />
            </InfoBubble>
          </div>
        )}
      {' '}
      <Tabs
        value={pathname}
        onChange={(tab) => push(tab)}
        style={{ maxHeight: '50px' }}
      >
        <Tab value={routes.registerEnrolment}>Ny</Tab>
        <Tab value={routes.registeredEnrolments}>
          <>
            Innsendte
            {!!unreadEnrolmentCount && (
              <IconBadgeNumber small>
                {unreadEnrolmentCount > 9 ? '9+' : unreadEnrolmentCount}
              </IconBadgeNumber>
            )}
          </>
        </Tab>
      </Tabs>
    </div>
  );
};
